import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { BUTTON_STATUS, CARD_BUTTON_ACTION, ERROR_CODES, STATUS_JOB } from 'src/helpers/constants'
import { observer } from 'mobx-react-lite'
import { useStore } from 'src/hooks'
import BaseButton from 'src/common/components/button'
import { size } from 'lodash'

type CardItemButtonProps = {
   status?: number
   id?: number
   count: number
   handleRefreshJobs: () => void
   isPriority: any
   targetId: any
}
// const { confirm } = Modal

const CardItemButton: React.FC<CardItemButtonProps> = observer(
   ({ status, id, handleRefreshJobs, isPriority, targetId }) => {
      const AuthStore = useStore('AuthStore')
      const JobsStore = useStore('JobsStore')
      const [buttonStatus, setButtonStatus] = useState<any>(BUTTON_STATUS[0])
      useEffect(() => {
         //type= prioritize
         setButtonStatus(BUTTON_STATUS.find((item: any) => item.status === status))
      }, [])
      const handleButtonAction = async () => {
         const buttonAction: any = CARD_BUTTON_ACTION.find((item) => item.status === status)
         try {
            const result = await JobsStore.action__cardBtn(`${buttonAction?.path}/${id}`)
            if (result?.code === ERROR_CODES.SUCCESS) {
               handleRefreshJobs()
            }
         } catch (e) {
            // console.log(e)
         } finally {
         }
      }

      const handleClickCardButton = async (event: any) => {
         event.stopPropagation()
         const buttonAction: any = CARD_BUTTON_ACTION.find((item) => item.status === status)
         if (buttonAction?.isAction) {
            await AuthStore.action_getProfile()
            const result: any = await JobsStore.isAbleToReceiveJobs()
            if (result?.isReceive === true) {
               // Nhan viec luon, khong hien modal xac nhan nua
               handleButtonAction()
            }
         }
      }

      return (
         <>
            {status !== STATUS_JOB.NEW && (
               <BaseButton
                  type={isPriority ? 'prioritize' : (targetId && size(targetId) > 0) ? 'tag_designer' : buttonStatus.type}
                  padding={buttonStatus?.padding}
                  size="sm"
                  className="content-footer__btn"
                  onClick={(e: any) => handleClickCardButton(e)}
               >
                  {/* Viec uu tien: giu mau do (type prioritize), chu doi thanh "Uu tien" */}
                  {isPriority ? 'Ưu tiên' : buttonStatus.label}
               </BaseButton>
            )}
         </>
      )
   }
)

export default CardItemButton
